<template lang="html">
    <div v-if="showLoading" class="pg-loading-screen" :class="showScreen ? 'pg-loading-screen-show' : ''">
        <div class="pg-loading-center-outer">
            <div class="pg-loading-center-middle">
                <div class="pg-loading-html" :class="showMessage ? 'pg-loading-html-show' : ''">
                    <p class="loading-message">{{ message }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading',
        data(){
            return {
                showLoading: false,
                showScreen: false,
                showMessage: false
            }
        },
        computed: {
            show(){
                return this.$store.state.Loading.show
            },
            message(){
                return this.$store.state.Loading.message
            }
        },
        watch: {
            show(value){
                if(value){
                    this.showLoading = true
                    return
                }

                this.showScreen = this.showMessage = false
                setTimeout(() => this.showLoading = false, 700)
            },
            showLoading(value){
                if( ! value )
                    return

                setTimeout(() => this.showScreen = !this.showScreen, 10)
                setTimeout(() => this.showMessage = !this.showMessage, 700)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pg-loading-screen {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        z-index: 16000002;
        background: rgba(0, 0, 0, 0);
        -webkit-transition: background .3s ease-out;
        -moz-transition: background .3s ease-out;
        -o-transition: background .3s ease-out;
        transition: background .3s ease-out;
    }

    .pg-loading-screen-show {
        background: rgba(0, 0, 0, 0.7);
    }

    .pg-loading-center-outer {
        width: 100%;
        padding: 0;
        display: table !important;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        margin: 0;
    }

    .pg-loading-center-middle {
        padding: 0;
        vertical-align: middle;
        display: table-cell  !important;
        margin: 0;
        text-align: center;
    }

    .pg-loading-logo-header {
        opacity: 0;
        -webkit-transition: opacity 1s ease-out;
        -moz-transition: opacity 1s ease-out;
        -o-transition: opacity 1s ease-out;
        transition: opacity 1s ease-out;
    }

    .pg-loading-logo-header img {
        display: inline-block !important;
    }

    .pg-loading-logo-header-show {
        opacity: 1;
    }

    .pg-loading-html {
        opacity: 0;
        -webkit-transition: opacity 1s ease-out;
        -moz-transition: opacity 1s ease-out;
        -o-transition: opacity 1s ease-out;
        transition: opacity 1s ease-out;
    }

    .pg-loading-html-show {
        opacity: 1;
    }

    .loading-message {
        margin-top: 40px;
        color: #fff;
        font-size: 24px;
        font-weight: 100;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .2s
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// Loading.vue?ed17f7fa